import Image from "next/image";
import { MatchupBasicTeam } from "./MatchupMainWrapper";
import styles from "./preMatchupMain.module.scss";

interface PreMatchupMainProps {
  homeTeam: MatchupBasicTeam;
  awayTeam: MatchupBasicTeam;
}

const PreMatchupMain = ({ homeTeam, awayTeam }: PreMatchupMainProps) => {
  return (
    <div className={styles.desktopContainer} data-testid="desktop-matchup-svg">
      <div
        className={styles.awayColor}
        style={{ backgroundColor: awayTeam.primaryColor }}
      />
      <div
        className={styles.awayStripe}
        style={{ backgroundColor: awayTeam.secondaryColor }}
      />
      <div
        className={styles.homeColor}
        style={{ backgroundColor: homeTeam.primaryColor }}
      />
      <div
        className={styles.homeStripe}
        style={{ backgroundColor: homeTeam.secondaryColor }}
      />
      <Image
        src={awayTeam.logoSVG}
        width={100}
        height={100}
        alt="Away Team Logo"
        className={styles.awayTeamLogo}
      />
      <Image
        src={homeTeam.logoSVG}
        width={100}
        height={100}
        alt="Home Team Logo"
        className={styles.homeTeamLogo}
      />
    </div>
  );
};

export default PreMatchupMain;
